.badgeContent {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem; /* gap-1 */
  padding-left: 0.5rem; /* px-2 */
  padding-right: 0.5rem;
  padding-top: 0.125rem; /* py-0.5 */
  padding-bottom: 0.125rem;
}

.dot {
  width: 0.5rem; /* w-2 */
  height: 0.5rem; /* h-2 */
  border-radius: 9999px;
  background: currentColor; /* bg-current */
}

.active {
  background-color: #dcfce7; /* green-100 */
  color: #047857; /* green-700 */
  border: 1px solid #bbf7d0; /* green-200 */
}

.inactive {
  background-color: #fee2e2; /* red-100 */
  color: #b91c1c; /* red-700 */
  border: 1px solid #fecaca; /* red-200 */
}

.verified {
  background-color: #dbeafe; /* blue-100 */
  color: #1d4ed8; /* blue-700 */
  border: 1px solid #bfdbfe; /* blue-200 */
}

.unverified {
  background-color: #fef9c3; /* yellow-100 */
  color: #a16207; /* yellow-700 */
  border: 1px solid #fcd34d; /* yellow-200 */
}

